import { Component, inject, Input } from '@angular/core';
import { Pagination } from '@core/models/pagination.model';
import { Store } from '@ngxs/store';
import { TableActions } from 'app/auth/table-store/table.actions';

@Component({
  selector: 'app-table-refresh',
  standalone: true,
  imports: [],
  templateUrl: './table-refresh.component.html',
  styleUrl: './table-refresh.component.scss'
})
export class TableRefreshComponent {
 @Input() tableKey!: string;
 store = inject(Store);

 refreshTable() {
  console.log('Refreshing table:', this.tableKey);
   this.store.dispatch(new TableActions.LoadTableData({
          tableKey: this.tableKey,
          params: new Pagination({ 
            skip: 0, 
            size: 10 
          }), 
        }));
      }
 }
